import classnames from 'classnames';
import React, { SyntheticEvent } from 'react';
import {
  DropdownMenu,
  DropdownMenuProps,
  DropdownToggle,
  DropdownToggleProps,
  UncontrolledDropdown as Dropdown,
} from 'reactstrap';
import { Direction } from 'reactstrap/lib/Dropdown';

export { DropdownItem } from 'reactstrap';

// eslint-disable-next-line @typescript-eslint/naming-convention
export interface IUncontrolledDropdown {
  className?: string;
  direction?: Direction;
  menu: {
    props?: DropdownMenuProps;
    children: React.ReactNode;
  };
  toggle: {
    dataTestId: string;
    children: React.ReactNode;
    props?: DropdownToggleProps;
  };
  isContextMenuEnabled?: boolean;
}

export const suppressContextMenuHandler = (e: SyntheticEvent) => {
  e.preventDefault();
  e.stopPropagation();
};

export const UncontrolledDropdown: React.FC<IUncontrolledDropdown> = ({
  className,
  direction = 'down' as Direction,
  menu,
  toggle,
  isContextMenuEnabled = true,
}) => {
  const renderMenuArrow = <span className="dropdown-menu-arrow" />;

  return (
    <Dropdown direction={direction} className={classnames(className)}>
      <DropdownToggle {...toggle.props} data-test-id={toggle.dataTestId}>
        {toggle.children}
      </DropdownToggle>
      <DropdownMenu {...menu.props} {...(isContextMenuEnabled ? {} : { onContextMenu: suppressContextMenuHandler })}>
        {direction === 'down' && renderMenuArrow}
        <div className="dropdown-menu-items">{menu.children}</div>
        {direction === 'up' && renderMenuArrow}
      </DropdownMenu>
    </Dropdown>
  );
};
